import pxToRem from "assets/theme/functions/pxToRem";

const tableHead = {
  styleOverrides: {
    root: {
      display: "block",
      padding: `${pxToRem(14)} ${pxToRem(14)} 0 ${pxToRem(14)}`,
      backgroundColor: "#F8FAFC",
      borderBottom: "1px solid #E2E8F0",
      borderRadius: "16px 16px 0 0",
    },
  },
};

export default tableHead;
